export default __webpack_public_path__ + "static/media/5_english.7abff03c.jpg";